import { t } from "drupal";
import { PanelBody, TextControl, TextareaControl, SelectControl, ColorPalette, Notice } from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';
import { useState, useEffect } from "@wordpress/element";

/**
 * This is the side panel component for Fast Facts. It displays the user form
 * as well as handle all the logic for the block. If Fast Facts uses rich text
 * in the future, move the logic to edit.js
 */

const FastFactsSidePanel = ({ attributes, setAttributes }) => {
  const {
    cards = [],
    availableIcons = [],
    textColorClass = '',
    headingColorClass = '',
    title = "",
    titleError = "",
    numOfFactsError = "",
    iconError = ""
  } = attributes;

  // console.log("Fast Facts side Panel: ", { title, cards, textColorClass, headingColorClass });

  const [errors, setErrors] = useState({});

  const updateNumCards = (value) => {
    const newNumCards = parseInt(value);
    // console.log("inside updateNumCards");
    if (isNaN(newNumCards)) return; // Prevent updating if placeholder is selected

    const updatedCards = [...cards];
    if (newNumCards > cards.length) {
      // console.log('newNumCards', newNumCards);
      // console.log('cards.length', cards.length);
      for (let i = cards.length; i < newNumCards; i++) {
        updatedCards.push({
          title: ``,
          text: ``,
          icon: `/modules/custom/deohs_gutenberg_blocks/blocks/deohs-fast-facts/icons/fast-facts-icons-web-02.png`,
          altText: "decorative"
        });
      }
    } else {
      updatedCards.length = newNumCards;
    }
      setAttributes({
    ...attributes,
    cards: updatedCards,
  });
};
  const onChangeTitle = (value) => setAttributes({ title: value });

  const updateCardTitle = (index, value) => {
    const updatedCards = [...cards];
    updatedCards[index].title = value;
      setAttributes({
    ...attributes,
    cards: updatedCards,
  });
};



  const updateCardText = (index, value) => {
    const updatedCards = [...cards];
    updatedCards[index].text = value;
      setAttributes({
    ...attributes,
    cards: updatedCards,
  });
};



  const updateCardIcon = (index, value) => {
    const updatedCards = [...cards];

    // Find the selected icon in availableIcons
    const selectedIcon = availableIcons.find(icon => icon.url === value);

    // Store both the icon URL and its ALT text in the card object
    updatedCards[index].icon = value;
    // updatedCards[index].altText = selectedIcon ? selectedIcon.alt : "";
    // this appears in the editor
    updatedCards[index].altText = "decorative";


      setAttributes({
    ...attributes,
    cards: updatedCards,
  });
};




  const textOptions = [
    { name: 'Black', color: '#000000', class: 'black' },
    { name: 'White', color: '#FFF', class: 'white' },
  ];

  const headingOptions = [
    { name: 'Purple', color: '#32006e', class: 'purple' },
    { name: 'Dark Grey', color: '#404040', class: 'darkgrey' },
    { name: 'Lite Grey', color: '#e5e5e5', class: 'litegrey' },
    { name: 'White', color: '#ffffff', class: 'white' },
    { name: 'Black', color: '#000000', class: 'black' },
  ];


  useEffect(() => {
    const titleError = !title?.trim();
    const numOfFactsError = !cards.length;
    const iconError = cards.some(card => !card.icon?.trim());

    setAttributes({
      titleError,
      numOfFactsError,
      iconError
    });
  }, [title, cards]);

  return (
    <InspectorControls>
      <PanelBody title={t('Fast Facts Settings')} initialOpen={true}>
        {/* Title */}
        {titleError && <Notice status="error">{t("Fast Facts Title is required")}</Notice>}
        <TextControl
          label={t('Fast Facts Title ')}
          value={title}
          required
          onChange={(value) => {
            const trimmedValue = value?.trim() ?? "";
            onChangeTitle(value, "title");
          }}
        />

        {/* Number of Cards Selection */}
        {numOfFactsError && <Notice status="error">{t("Number of Fast Facts is required")}</Notice>}
        <SelectControl
          label={t('Number of Fast Facts')}
          value={cards.length ? String(cards.length) : ''}
          options={[
            { label: 'Select number of Fast Facts', value: '' },  // Placeholder option
            { label: '3 Fast Facts', value: '3' },
            { label: '4 Fast Facts', value: '4' }
          ]}
          onChange={(value) => {
            if (!value) {
              setAttributes({ cards: [] });
            } else {
              const numFacts = parseInt(value, 10);
              const newCards = Array.from({ length: numFacts }, (_, index) => ({
                ...cards[index],
                title: cards[index]?.title || '',
                text: cards[index]?.text || '',
                icon: cards[index]?.icon || '',
              }));
              setAttributes({
                cards: newCards,
                textColorClass: attributes.textColorClass || '',
                headingColorClass: attributes.headingColorClass || ''
              });

            }
          }}

        />

        {cards.map((card, index) => {
          // Find the selected icon's ALT text
          const selectedIcon = availableIcons.find(icon => icon.url === card.icon);
          // const altText = selectedIcon ? selectedIcon.alt : t('Fast Fact Icon');
          // this appearsin the side panel
          const altText = t('decorative');

          return (
            <div key={index}>
              <hr />
              <br />

              {/* Icon Selection Dropdown */}
              {iconError && <Notice status="error">{t("An icon must be selected for each Fast Fact. Scroll down page to ensure all icons for all facts are selected.")}</Notice>}
              <SelectControl
                label={t('Select Icon for Fact ') + (index + 1)}
                value={card.icon}
                options={[
                  { label: 'Select an icon', value: '' },  // Placeholder option
                  ...availableIcons.map((icon) => ({
                    label: icon.label,
                    value: icon.url
                  }))
                ]}
                onChange={(value) => updateCardIcon(index, value)}
              />
              {/* Display ALT Text for Selected Icon */}
              {/* <p className="small">
                <strong>{t('Icon ALT Text:')}</strong> {card.altText || altText}
              </p> */}

              {/* Title Input */}
              <TextControl
                label={t('Fact Title ') + (index + 1)}
                value={card.title}
                onChange={(value) => updateCardTitle(index, value)}
              />

              {/* Character Count for Title */}
              <p className="small">{t('Character Count:')} {card.title.length} / 50</p>

              {/* Textarea Input */}
              <TextareaControl
                label={t('Fact Text ') + (index + 1)}
                value={card.text}
                rows={5}
                onChange={(value) => updateCardText(index, value)}
              />

              {/* Character Count for Text */}
              <p className="small">{t('Character Count:')} {card.text.length} / 150</p>
            </div>
          );
        })}

        <label className="form-label">{t("Heading Color")}</label>
        <ColorPalette
          colors={headingOptions}
          value={headingOptions.find(opt => opt.class === headingColorClass)?.color}
          onChange={(color) => {
            const selected = headingOptions.find(opt => opt.color === color);
            if (selected) {
              setAttributes({ headingColorClass: selected.class });
            }
          }}
        />

        <label className="form-label">{t("Text Color")}</label>
        <ColorPalette
          colors={textOptions}
          value={textOptions.find(opt => opt.class === textColorClass)?.color}
          onChange={(color) => {
            const selected = textOptions.find(opt => opt.color === color);
            if (selected) {
              setAttributes({ textColorClass: selected.class });
            }
          }}
        />

      </PanelBody>
    </InspectorControls>
  );
};

export default FastFactsSidePanel;
